import { css, cx } from "@emotion/css"

import COLOR_CODE from "../../../constant/color"
import rowStyles from "./rowStyles"

type Props = { repeatOrderCount: number | null }

const Head = ({ repeatOrderCount }: Props) => {
  return (
    <>
      <div className={cx(styles.head, rowStyles.title, styles.title)} />
      <div className={cx(styles.head, rowStyles.first)}>初回</div>
      {repeatOrderCount && repeatOrderCount >= 2 && (
        <div className={cx(styles.head, rowStyles.total)}>リピート{"\n"}1回目の総額</div>
      )}
      {repeatOrderCount && repeatOrderCount >= 3 && (
        <div className={cx(styles.head, rowStyles.total)}>リピート{"\n"}2回目の総額</div>
      )}
      <div className={cx(styles.head, rowStyles.ellipsis, styles.ellipsis)} />
      <div className={cx(styles.head, rowStyles.total)}>
        <span>
          リピート{"\n"}
          <span className={styles.redText}>{repeatOrderCount ?? "ー"}</span>回目の総額
        </span>
      </div>
    </>
  )
}

export default Head

const styles = {
  title: css`
    background-color: inherit;
    border: none;
  `,
  ellipsis: css`
    background-color: inherit;
  `,
  head: css`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 126px;
    font-size: 13px;
    font-weight: bold;
    text-align: center;
    white-space: pre-line;
    background-color: ${COLOR_CODE.SIMULATION_COURSE_GRAY};

    border: none;
  `,
  redText: css`
    color: ${COLOR_CODE.SIMULATION_RED};
  `,
}
